import { motion } from "framer-motion";
import Layout from '@/components/Layout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { SEO } from '@/components/SEO';
import { BarChart3, PieChart, LineChart, Lock } from "lucide-react";

const reportTypes = [
  {
    icon: <BarChart3 className="w-8 h-8 text-violet-500" />,
    title: "Task Analytics",
    description: "Track task completion rates, cycle times, and team velocity metrics.",
    comingSoon: true
  },
  {
    icon: <PieChart className="w-8 h-8 text-violet-500" />,
    title: "Resource Allocation",
    description: "Analyze team workload distribution and project resource utilization.",
    comingSoon: true
  },
  {
    icon: <LineChart className="w-8 h-8 text-violet-500" />,
    title: "Performance Trends",
    description: "Monitor service uptime, response times, and incident patterns.",
    comingSoon: true
  }
];

const Reports = () => {
  return (
    <Layout>
      <SEO 
        title="Reports"
        description="Access detailed analytics and insights about your projects, tasks, and monitoring data."
      />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="container space-y-8"
      >
        <div className="text-center space-y-4">
          <h1 className="text-3xl font-bold">Reports & Analytics</h1>
          <p className="text-muted-foreground container mx-auto">
            Gain valuable insights into your projects and team performance with detailed analytics and customizable reports.
          </p>
        </div>

        <Card className="border-2 border-violet-500/20 bg-violet-500/5">
          <CardContent className="p-8">
            <div className="flex flex-col items-center justify-center space-y-4 py-12">
              <div className="p-4 bg-violet-500/10 rounded-full">
                <Lock className="w-12 h-12 text-violet-500" />
              </div>
              <h2 className="text-2xl font-semibold">Reports Unavailable</h2>
              <p className="text-center text-muted-foreground max-w-lg text-lg">
                Advanced reporting features are not available on your current plan. Upgrade to access detailed analytics and insights.
              </p>
              <Button 
                size="lg" 
                className="mt-6"
                onClick={() => window.location.href = 'mailto:enterprise@status.bot'}
              >
                Contact Enterprise Support
              </Button>
            </div>
          </CardContent>
        </Card>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 pb-8">
          {reportTypes.map((report) => (
            <Card key={report.title} className="border-2 border-violet-500/20">
              <CardContent className="p-8 space-y-6">
                <div className="p-3 bg-violet-500/10 rounded-lg w-fit">
                  {report.icon}
                </div>
                <div className="space-y-3">
                  <div className="flex items-center gap-2">
                    <h3 className="text-lg font-semibold">{report.title}</h3>
                    <span className="text-xs bg-violet-500/10 text-violet-500 px-2 py-1 rounded-full">
                      Coming Soon
                    </span>
                  </div>
                  <p className="text-muted-foreground">
                    {report.description}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </motion.div>
    </Layout>
  );
};

export default Reports; 